import React, { FC } from "react";
import "../../assets/style/3_components/c-playbackInformation.scss";
import { TimeFormatter } from "../../utils/TimeFormatter";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  title: string;
  videoCode: string;
  currentPart: number;
  markerName: string;
  currentPartTime: number;
  currentPartDuration: number;
  totalTime: number;
  highlightNewPart?: boolean;
  highlightDuration?: number;
};

export const DebugInformation: FC<Props> = (props) => {
  const {
    className,
    style,
    title,
    videoCode,
    currentPart,
    markerName,
    currentPartTime,
    currentPartDuration,
    totalTime,
    highlightNewPart,
    highlightDuration,
  } = props;

  const highlight = highlightNewPart && currentPartTime < highlightDuration / 1000;

  return (
    <div className={`c-debugInformation ${className || ""}`} style={style || {}}>
      <div className="c-debugInformation--title">{title}</div>

      <div className="c-debugInformation--videoCode">{videoCode}</div>

      <div className="c-debugInformation--parts">
        <div className="c-debugInformation--partText">PART</div>
        <div className="c-debugInformation--currentPart">{currentPart}</div>
        <div className="c-debugInformation--markerName">{markerName}</div>
      </div>

      <div className={`c-debugInformation--times ${highlight ? "c-debugInformation--times--highlight" : ""}`}>
        <div className="c-debugInformation--currentTime">{TimeFormatter.format(totalTime, true)}</div>
        <div className="c-debugInformation--currentPartDuration">{TimeFormatter.format(currentPartTime, true)}</div>
      </div>

      <div className="c-debugInformation--progress">
        <div className="c-debugInformation--progressBar" style={{ width: `${(currentPartTime / currentPartDuration) * 100}%` }} />
      </div>
    </div>
  );
};
